import { ThunkAction } from 'redux-thunk';

import { DownloadConditions, downloadSearchResult } from '../services/contractApi';
export { DownloadConditions } from '../services/contractApi';

/**
 * 検索結果-TSVダウンロード用モジュール
 */
export interface DownloadState {
  searchDownload: Promise<Blob> | null;
  downloadMessages: string[];
  statusT: number;
}

const initialState: DownloadState = {
  searchDownload: null,
  downloadMessages: [],
  statusT: 0,
};

const REQUEST_DOWNLOAD = 'REQUEST_DOWNLOAD';
type REQUEST_DOWNLOAD = typeof REQUEST_DOWNLOAD;

const RECEIVE_DOWNLOAD = 'RECEIVE_DOWNLOAD';
type RECEIVE_DOWNLOAD = typeof RECEIVE_DOWNLOAD;

const FAIL_DOWNLOAD = 'FAIL_DOWNLOAD';
type FAIL_DOWNLOAD = typeof FAIL_DOWNLOAD;

const CLEAR_DOWNLOAD = 'CLEAR_DOWNLOAD';
type CLEAR_DOWNLOAD = typeof CLEAR_DOWNLOAD;

const CLEAR_DOWNLOAD_MESSAGES = 'CLEAR_DOWNLOAD_MESSAGES';
type CLEAR_DOWNLOAD_MESSAGES = typeof CLEAR_DOWNLOAD_MESSAGES;

interface RequestDownload {
  type: REQUEST_DOWNLOAD;
}

interface ReceiveDownload {
  type: RECEIVE_DOWNLOAD;
  searchDownload: Promise<Blob>;
}

interface FailDownload {
  type: FAIL_DOWNLOAD;
  downloadMessages: string[];
  status: number;
}

interface ClearDownload {
  type: CLEAR_DOWNLOAD;
}

interface ClearDownloadMessages {
  type: CLEAR_DOWNLOAD_MESSAGES;
}

export type DownloadAction = RequestDownload | ReceiveDownload |
  FailDownload | ClearDownload | ClearDownloadMessages;

type DownloadDocuments =
  ThunkAction<void, DownloadState, undefined, DownloadAction>;

export function requestDownload(): RequestDownload {
  return {
    type: REQUEST_DOWNLOAD,
  };
}

export function receiveDownload(searchDownload: Promise<Blob>): ReceiveDownload {
  return {
    searchDownload,
    type: RECEIVE_DOWNLOAD,
  };
}

export function failDownload(downloadMessages: string[], status: number): FailDownload {
  return {
    downloadMessages,
    status,
    type: FAIL_DOWNLOAD,
  };
}

export function clearDownload(): ClearDownload {
  return {
    type: CLEAR_DOWNLOAD,
  };
}

export function clearDownloadMessages(): ClearDownloadMessages {
  return {
    type: CLEAR_DOWNLOAD_MESSAGES,
  };
}

export function downloadDocuments(conditions: DownloadConditions): DownloadDocuments {
  return (dispatch) => {
    dispatch(requestDownload());
    // ダウンロードAPI呼び出し
    return downloadSearchResult(conditions).then((res) => {
      if (res.status === 200 && res) {
        dispatch(receiveDownload(res.blob()));
      } else {
        dispatch(failDownload([String(res.statusText)], res.status));
      }
    }).catch((err) => {
      dispatch(failDownload([String(err)], 500));
    });
  };
}

export default function reducer(
  state: DownloadState | undefined,
  action: DownloadAction,
): DownloadState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_DOWNLOAD: {
      return state;
    }
    case RECEIVE_DOWNLOAD: {
      const { searchDownload } = action;
      return { searchDownload, downloadMessages: [], statusT: 200 };
    }
    case FAIL_DOWNLOAD: {
      const { downloadMessages, status } = action;
      return { ...state, downloadMessages, statusT: status, searchDownload: null };
    }
    case CLEAR_DOWNLOAD: {
      return initialState;
    }
    case CLEAR_DOWNLOAD_MESSAGES: {
      return { ...state, downloadMessages: [] };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/searchTsv.ts